(function () {
  var ZOOM_MIN = 0.4;
  var ZOOM_MAX = 2.5;
  var ZOOM_STEP = 0.02;
  var EXPORT_VERSION = 2;
  var DEFAULT_BOTTOM = 0.17;

  /** @type {Array<any>} */
  var allEntries = [];

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function resolveModelos(products, catalog) {
    var byId = {};
    var byHandle = {};
    (catalog || []).forEach(function (m) {
      if (m.id != null && m.id !== '') byId[String(m.id)] = m;
      if (m.handle) byHandle[m.handle] = m;
    });

    products.forEach(function (p) {
      var meta = null;
      if (p.modeloId && byId[String(p.modeloId)]) meta = byId[String(p.modeloId)];
      else if (p.modelo && byHandle[p.modelo]) meta = byHandle[p.modelo];
      if (meta) {
        p.modelo = meta.handle || p.modelo;
        p.modeloLabel = meta.nome || meta.handle || p.modelo;
      } else if (p.modelo) {
        p.modeloLabel = p.modelo.replace(/-/g, ' ');
      } else {
        p.modelo = '_sem-modelo';
        p.modeloLabel = 'Sem modelo';
      }
    });
  }

  function groupByModelo(products) {
    var groups = Object.create(null);
    products.forEach(function (p) {
      var key = p.modelo || '_sem-modelo';
      if (!groups[key]) {
        groups[key] = {
          modelo: key,
          label: p.modeloLabel || key,
          items: [],
        };
      }
      groups[key].items.push(p);
    });
    return Object.keys(groups)
      .sort(function (a, b) {
        return groups[a].label.localeCompare(groups[b].label, 'pt-BR');
      })
      .map(function (k) {
        groups[k].items.sort(function (a, b) {
          if (a.isReference && !b.isReference) return -1;
          if (!a.isReference && b.isReference) return 1;
          return a.handle.localeCompare(b.handle);
        });
        return groups[k];
      });
  }

  function matrixFor(product, matrixByModelo) {
    return matrixByModelo[product.modelo] || {
      contentH: null,
      bottomGap: 0.17,
      scaleMul: 1,
      offsetX: 0,
      offsetY: 0,
      referenceHandle: '',
    };
  }

  function combinedScaleMul(entry) {
    return Number((entry.matrix.scaleMul * entry.extraScaleMul).toFixed(4));
  }

  function bottomGapOf(entry) {
    var g = entry.matrix && entry.matrix.bottomGap;
    return g == null ? DEFAULT_BOTTOM : g;
  }

  function sampleFill(img) {
    try {
      var c = document.createElement('canvas');
      c.width = 8;
      c.height = 8;
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, 8, 8);
      var d = ctx.getImageData(0, 0, 1, 1).data;
      return 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')';
    } catch (err) {
      return '#f6f6f6';
    }
  }

  function loadBaked(entry) {
    if (entry.bakedImg) return Promise.resolve(entry.bakedImg);
    if (entry.bakedPromise) return entry.bakedPromise;
    entry.bakedPromise = new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        entry.bakedImg = img;
        entry.fillColor = sampleFill(img);
        resolve(img);
      };
      img.onerror = function () {
        reject(new Error('fail baked ' + entry.product.handle));
      };
      img.src = entry.product.previewUrl;
    });
    return entry.bakedPromise;
  }

  /**
   * 100% = JPEG já gerado (matriz aplicada).
   * Zoom escala essa foto em torno da linha de bottom, sem reprocessar o original.
   */
  function renderFromBaked(entry) {
    var src = entry.bakedImg;
    var w = src.naturalWidth || src.width;
    var h = src.naturalHeight || src.height;
    var scale = entry.extraScaleMul;
    var pivotY = h * (1 - bottomGapOf(entry));
    var cx = w / 2;

    var out = document.createElement('canvas');
    out.width = w;
    out.height = h;
    var ctx = out.getContext('2d');
    ctx.fillStyle = entry.fillColor || '#f6f6f6';
    ctx.fillRect(0, 0, w, h);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.translate(cx, pivotY);
    ctx.scale(scale, scale);
    ctx.translate(-cx, -pivotY);
    ctx.drawImage(src, 0, 0, w, h);
    return out.toDataURL('image/jpeg', 0.92);
  }

  function showBaked(entry) {
    if (!entry.imgEl) return;
    if (entry.extraScaleMul === 1) {
      entry.imgEl.src = entry.product.previewUrl;
      return;
    }
    entry.imgEl.src = renderFromBaked(entry);
  }

  function updateZoomUi(entry) {
    if (entry.zoomValEl) {
      entry.zoomValEl.textContent = Math.round(entry.extraScaleMul * 100) + '%';
    }
    if (entry.zoomMinusEl) {
      entry.zoomMinusEl.disabled = entry.extraScaleMul <= ZOOM_MIN + 0.001;
    }
    if (entry.zoomPlusEl) {
      entry.zoomPlusEl.disabled = entry.extraScaleMul >= ZOOM_MAX - 0.001;
    }
    if (entry.ajusteBadge) {
      entry.ajusteBadge.hidden = entry.extraScaleMul === 1;
    }
  }

  async function nudgeZoom(entry, delta) {
    var prev = entry.extraScaleMul;
    var next = clamp(Number((prev + delta).toFixed(4)), ZOOM_MIN, ZOOM_MAX);
    if (next === prev) return;
    try {
      await loadBaked(entry);
      entry.extraScaleMul = next;
      showBaked(entry);
    } catch (err) {
      entry.extraScaleMul = prev;
    }
    updateZoomUi(entry);
    refreshExportState();
  }

  function tweakedEntries() {
    return allEntries.filter(function (e) {
      return e.extraScaleMul !== 1;
    });
  }

  function refreshExportState() {
    var btn = document.querySelector('[data-gm-ajuda-aprovacao-export]');
    if (!btn) return;
    btn.disabled = tweakedEntries().length === 0;
  }

  function downloadJson() {
    var tweaked = tweakedEntries();
    if (!tweaked.length) return;
    var payload = {
      version: EXPORT_VERSION,
      kind: 'aprovacao-ajustes',
      basedOn: 'docs/gm-fotos-referencia-2026-09-16-18-49-39.json',
      exportedAt: new Date().toISOString(),
      canvas: { width: 1650, height: 2200 },
      entries: tweaked.map(function (entry) {
        return {
          handle: entry.product.handle,
          modelo: entry.product.modelo,
          modeloLabel: entry.product.modeloLabel,
          isReference: !!entry.product.isReference,
          matrixScaleMul: entry.matrix.scaleMul,
          extraScaleMul: Number(entry.extraScaleMul.toFixed(4)),
          scaleMul: Number(combinedScaleMul(entry).toFixed(4)),
          contentH: entry.matrix.contentH,
          bottomGap: entry.matrix.bottomGap,
          offsetX: entry.matrix.offsetX || 0,
          offsetY: entry.matrix.offsetY || 0,
        };
      }),
    };
    var blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    var stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
    a.href = url;
    a.download = 'gm-fotos-aprovacao-ajustes-' + stamp + '.json';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  function buildCard(entry) {
    var p = entry.product;
    var card = document.createElement('article');
    card.className = 'gm-ajuda-ref__card';
    if (p.isReference) card.classList.add('is-reference');

    var media = document.createElement('div');
    media.className = 'gm-ajuda-ref__media';

    var img = document.createElement('img');
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.src = p.previewUrl;
    media.appendChild(img);

    if (p.isReference) {
      var matrizBadge = document.createElement('span');
      matrizBadge.className = 'gm-ajuda-ref__badge gm-ajuda-aprovacao__badge--matriz';
      matrizBadge.textContent = 'matriz';
      media.appendChild(matrizBadge);
    }

    var ajusteBadge = document.createElement('span');
    ajusteBadge.className = 'gm-ajuda-ref__badge gm-ajuda-aprovacao__badge--ajuste';
    ajusteBadge.textContent = 'ajuste';
    ajusteBadge.hidden = true;
    media.appendChild(ajusteBadge);

    var zoom = document.createElement('div');
    zoom.className = 'gm-ajuda-ref__zoom';

    var btnMinus = document.createElement('button');
    btnMinus.type = 'button';
    btnMinus.className = 'gm-ajuda-ref__zoom-btn';
    btnMinus.setAttribute('aria-label', 'Diminuir');
    btnMinus.textContent = '−';

    var zoomVal = document.createElement('span');
    zoomVal.className = 'gm-ajuda-ref__zoom-val';
    zoomVal.textContent = '100%';

    var btnPlus = document.createElement('button');
    btnPlus.type = 'button';
    btnPlus.className = 'gm-ajuda-ref__zoom-btn';
    btnPlus.setAttribute('aria-label', 'Aumentar');
    btnPlus.textContent = '+';

    zoom.appendChild(btnMinus);
    zoom.appendChild(zoomVal);
    zoom.appendChild(btnPlus);

    var foot = document.createElement('div');
    foot.className = 'gm-ajuda-ref__foot';
    var titleEl = document.createElement('p');
    titleEl.className = 'gm-ajuda-ref__modelo';
    titleEl.textContent = p.title + (p.draft ? ' · rascunho' : '');
    var handleEl = document.createElement('p');
    handleEl.className = 'gm-ajuda-ref__handle';
    var handleLink = document.createElement('a');
    handleLink.href = p.url;
    handleLink.textContent = p.handle;
    handleEl.appendChild(handleLink);
    foot.appendChild(titleEl);
    foot.appendChild(handleEl);

    card.appendChild(media);
    card.appendChild(zoom);
    card.appendChild(foot);

    entry.imgEl = img;
    entry.zoomValEl = zoomVal;
    entry.zoomMinusEl = btnMinus;
    entry.zoomPlusEl = btnPlus;
    entry.ajusteBadge = ajusteBadge;

    btnMinus.addEventListener('click', function () {
      nudgeZoom(entry, -ZOOM_STEP);
    });
    btnPlus.addEventListener('click', function () {
      nudgeZoom(entry, ZOOM_STEP);
    });

    return card;
  }

  async function init() {
    var section = document.querySelector('[data-gm-ajuda-aprovacao-matriz]');
    if (!section) return;
    var root = section.querySelector('[data-gm-ajuda-aprovacao-root]');
    var productsEl = section.querySelector('[data-gm-ajuda-aprovacao-products]');
    var modelosEl = section.querySelector('[data-gm-ajuda-aprovacao-modelos]');
    var exportBtn = section.querySelector('[data-gm-ajuda-aprovacao-export]');
    if (!root || !productsEl) return;

    var products;
    var catalog = [];
    var matrixDoc = { entries: [] };
    try {
      products = JSON.parse(productsEl.textContent || '[]');
      if (modelosEl) catalog = JSON.parse(modelosEl.textContent || '[]');
    } catch (err) {
      root.innerHTML = '<p class="gm-ajuda-ref__status">Erro ao carregar dados.</p>';
      return;
    }

    try {
      var matrizUrl = section.getAttribute('data-gm-ajuda-aprovacao-matriz');
      if (matrizUrl) {
        var res = await fetch(matrizUrl);
        if (res.ok) matrixDoc = await res.json();
      }
    } catch (err2) {
      matrixDoc = { entries: [] };
    }

    var matrixByModelo = Object.create(null);
    (matrixDoc.entries || []).forEach(function (e) {
      matrixByModelo[e.modelo] = e;
    });

    if (window.GmPhotoCatalog) {
      var catalogRows = await window.GmPhotoCatalog.load();
      products = window.GmPhotoCatalog.merge(products, catalogRows, window.GmPhotoCatalog.mapAprov);
    }

    resolveModelos(products, catalog);
    products.forEach(function (p) {
      var mx = matrixByModelo[p.modelo];
      p.isReference = !!(mx && mx.referenceHandle === p.handle);
    });

    var groups = groupByModelo(products);
    root.innerHTML = '';
    allEntries = [];

    groups.forEach(function (group) {
      var wrap = document.createElement('section');
      wrap.className = 'gm-ajuda-aprovacao__group';
      var head = document.createElement('h2');
      head.className = 'gm-ajuda-aprovacao__group-head';
      head.textContent = group.label + ' · ' + group.items.length;
      var grid = document.createElement('div');
      grid.className = 'gm-ajuda-ref__grid';
      wrap.appendChild(head);
      wrap.appendChild(grid);

      group.items.forEach(function (product) {
        var entry = {
          product: product,
          matrix: matrixFor(product, matrixByModelo),
          extraScaleMul: 1,
        };
        allEntries.push(entry);
        grid.appendChild(buildCard(entry));
      });

      root.appendChild(wrap);
    });

    if (exportBtn) {
      exportBtn.addEventListener('click', downloadJson);
    }
    refreshExportState();
  }

  function boot() {
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
